
import request from '@/utils/request.js'
// 获取新闻咨讯列表
let newsService='/news-service/'
export const getNewsList=params=>{return request({url:newsService+'getNewsList',method:'post',data:params})}
export const getNewsDetail=params=>{return request({url:newsService+'getNewsDetail',method:'post',data:params})}
// 新闻标签top10
export const getNewsOtherLabelTopList=params=>{return request({url:newsService+'getNewsOtherLabelTopList',method:'get',params})}

//案例客户
var customerurl = '/customer-service/';
//获取邮件列表
export const getCustomerList=params=>{return request({url:customerurl+'getCustomerList',method:'post',data:params})}
//获取案例客户详情
export const getCustomerDetail = params => { return request({ url: customerurl + 'getCustomerDetail', method: 'post', data: params }) }
// 编辑咨询信息
export const editConsultMail = params => { return request({ url: customerurl + 'editConsultMail', method: 'post', data: params }) }
// 订阅
export const editSubscribeMail = params => { return request({ url: customerurl + 'editSubscribeMail', method: 'post', data: params }) }
// 取消订阅
export const cancelSubscribeMail = params => { return request({ url: customerurl + 'cancelSubscribeMail', method: 'post', data: params }) }

// webinar
var webinarurl = '/webinar-service/' 
// webinar详情以及提交信息
export const editWebinarSubscribe=params=>{return request({url:webinarurl+'editWebinarSubscribe',method:'post',data:params})}
// 获取第一个webinar
export const getWebinarTopOne=params=>{return request({url:webinarurl+'getWebinarTopOne',method:'post',data:params})}
// report信息收集
export const collectWebinarApplicant = params => { return request({ url:webinarurl+'collectWebinarApplicant', method: 'post', data: params }) }

// news lable
var lableurl = '/label-service/'
// 一级 lable
export const getLabelFirstList = params => { return request({ url: lableurl + 'getLabelFirstList', method: 'post', data: params }) }
// 二级标签
export const getLabelSecondList = params => { return request({ url: lableurl + 'getLabelSecondList', method: 'post', data: params }) }

// panel
var panelurl = '/panel-service/'
// 下载panel
export const panelDownloads = params => { return request({ url: panelurl + 'panelDownloads', method: 'post', data: params }) }

// 人员
var teamurl = '/team-service/'
// leadership
export const getTeamMemberFirstList = params => { return request({ url: teamurl + 'getTeamMemberFirstList', method: 'post', data: params }) }
export const getTeamMemberSecondList = params => { return request({ url: teamurl + 'getTeamMemberSecondList', method: 'post', data: params }) }
export const getTeamMemberThirdList = params => { return request({ url: teamurl + 'getTeamMemberThirdList', method: 'post', data: params }) }

// 检测页面浏览情况
var publicurl='/public-service/'
export const advertisementFlow = params => { return request({ url: publicurl + 'advertisementFlow', method: 'post', data: params }) }
// 机器人
export const robotRecord = params => { return request({ url: publicurl + 'robotRecord', method: 'post', data: params }) }
// 公众号
export const publicityRecord = params => { return request({ url: publicurl + 'publicityRecord', method: 'post', data: params }) }


// 操作记录
var actionurl = '/action-service/'
export const actionRecords = params => { return request({ url: actionurl + 'actionRecords', method: 'post', data: params }) }

// 市场
var marketurl = '/market-service/'
export const getMarketsList = params => { return request({ url: marketurl + 'getMarketsList', method: 'post', data: params }) }

// 报价系统
var eadaurl = '/qualitative-service/'
// 获取rfq历史列表
export const getQuotationList = params => { return request({ url: eadaurl + 'getQuotationList', method: 'post', data: params }) }
// 获取rfq详情
export const getQuotationDetail = params => { return request({ url: eadaurl + 'getQuotationDetail', method: 'post', data: params }) }
// 新增询价
export const editQuotation = params => { return request({ url: eadaurl + 'editQuotation', method: 'post', data: params }) }
// 报价邮件
export const sendQuotationEMail = params => { return request({ url: eadaurl + 'sendQuotationEMail', method: 'post', data: params }) }



// 报价下拉框
var selecturl = '/select-service/'
// 获取ir
export const getIrList = params => { return request({ url: selecturl + 'getIrList', method: 'get', data: params }) }
// 获取定量loi
export const getQuantitativeLoiList = params => { return request({ url: selecturl + 'getQuantitativeLoiList', method: 'get', data: params }) }
// 获取定性loi
export const getQualitativeLoiList = params => { return request({ url: selecturl + 'getQualitativeLoiList', method: 'get', data: params }) }
// 获取target
export const getTargetList = params => { return request({ url: selecturl + 'getTargetList', method: 'get', data: params }) }
// 对话
export const getQuotationAnswer = params => { return request({ url: selecturl + 'getQuotationAnswer', method: 'post', data: params }) }
// 清除对话框
export const removeRedisValue = params => { return request({ url: selecturl + 'removeRedisValue', method: 'post', data: params }) }


// 登录
var oauthurl="/oauth/"
export const login = params => { return request({ url:oauthurl+"login", method: 'post', data: params }) }

var registerurl = "/eada/contactUs-service/"
// 注册
export const editContactUs = params => { return request({ url:registerurl+"editContactUs", method: 'post', data: params }) }
// 设置密码
export const setQuotationInfo = params => { return request({ url:registerurl+"setQuotationInfo", method: 'post', data: params }) }
// 获取详情
export const getEQuoteUserDetail = params => { return request({ url:registerurl+"getEQuoteUserDetail", method: 'post', data: params }) }
// 获取公司列表
export const getQuotationClientList = params => { return request({ url:'/select-service/getQuotationClientList', method: 'get', data: params }) }
// 忘记密码
export const forgotAccountPassword = params => { return request({ url:registerurl+'forgotAccountPassword', method: 'post', data: params }) }














